import { Flex } from 'foundations-components/components/Flex';
import { getButtonVariantProps } from 'pricing-pages-ui-components/utils/buttonVariantUtils';
import { SuiteCTA } from '../../../../features/purchaseMotions/components/SuiteCTA';
import { TalkToSalesFallback } from '../../../../features/purchaseMotions/components/TalkToSalesFallback';
import { useSuitePurchaseMotionsQuery } from '../../../../features/purchaseMotions/hooks/useSuitePurchaseMotionsQuery';
import { useGlobalLoading } from '../../../../hooks/loadingHooks';
import { ErrorBoundary } from '../../../../v2/components/error-boundary/ErrorBoundary';
import { ErrorBoundaryTrigger } from '../../../../v2/components/error-boundary/ErrorBoundaryTrigger';
import SkeletonLoadWrapper from '../../../common/loading/SkeletonLoadWrapper';
import { useCrmSuiteBundleSkuId } from '../../price-display/useCrmSuite';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SuiteCardCTAs = ({
  productLevel,
  screen,
  trackingSource
}) => {
  const isAppReady = useGlobalLoading();
  const {
    suitePurchaseMotions,
    error: suitePurchaseMotionsError,
    loading: suitePurchaseMotionsLoading
  } = useSuitePurchaseMotionsQuery({
    productLevel,
    location: 'MERCH_CARD'
  });
  const ctaVariantProps = getButtonVariantProps({
    variant: 'block'
  });
  const suiteSkuId = useCrmSuiteBundleSkuId({
    productLevel
  });
  const fallback = suiteSkuId ? /*#__PURE__*/_jsx(TalkToSalesFallback, {
    skuId: suiteSkuId,
    screen: screen,
    trackingSource: trackingSource
  }) : null;
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: !isAppReady || suitePurchaseMotionsLoading,
    heights: [47],
    widths: ['100%'],
    children: /*#__PURE__*/_jsxs(ErrorBoundary, {
      fallback: fallback,
      children: [/*#__PURE__*/_jsx(ErrorBoundaryTrigger, {
        error: suitePurchaseMotionsError
      }), /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        justifyContent: "center",
        gap: "200",
        inlineSize: "100%",
        children: suitePurchaseMotions.map((purchaseMotion, index) => {
          return /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(SuiteCTA, Object.assign({
              use: index === 0 ? 'primary' : 'secondary',
              purchaseMotion: purchaseMotion,
              productLevel: productLevel,
              trackingSource: trackingSource,
              screen: screen,
              purchaseMotionLocation: "MERCH_CARD"
            }, ctaVariantProps))
          }, String(purchaseMotion));
        })
      })]
    })
  });
};